document.addEventListener('toggle', (event) => {
  const activeDetails = event.target.closest('[data-product-accordion]');

  if (!activeDetails || !activeDetails.open) return;

  const productInfo = activeDetails.closest('product-info');
  const scope = productInfo || document;

  scope.querySelectorAll('[data-product-accordion][open]').forEach((details) => {
    if (details !== activeDetails) details.open = false;
  });
}, true);
